import React from 'react';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { translate } = useLanguage();

  const services = [
    translate('airportTransfers'),
    translate('limousineService'),
    translate('eventsService'),
    'Excursions Touristiques',
    translate('schoolTransport'),
    translate('pmrVehicles')
  ];

  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <div className="flex items-center space-x-4 mb-4">
                <img 
                  src="/luxor_logo_inverted.png" 
                  alt="Luxor Limousine" 
                  className="h-16 w-auto"
                />
                <div className="text-sm text-white/80">
                  <div className="font-semibold">LIMOUSINE SERVICE</div>
                  <div className="text-xs text-yellow-400">Montreux</div>
                </div>
              </div>
              <p className="text-gray-300 max-w-md leading-relaxed">
                {translate('companyDescription')}
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-300">
                <Phone className="w-5 h-5 text-yellow-500" />
                <span>+41 79 199 10 10 (24h/24)</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Mail className="w-5 h-5 text-yellow-500" />
                <span>info@luxor-limo.ch</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <MapPin className="w-5 h-5 text-yellow-500" />
                <span>1820 Montreux, Suisse</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{translate('services')}</h3>
            <div className="space-y-2">
              {services.map((service, index) => (
                <div key={index} className="text-gray-300 hover:text-yellow-400 cursor-pointer transition-colors">
                  {service}
                </div>
              ))}
            </div>
          </div>

          {/* Destinations */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">{translate('destinations')}</h3>
            <div className="space-y-2">
              <div className="text-gray-300">Genève</div>
              <div className="text-gray-300">Lausanne</div>
              <div className="text-gray-300">Zurich</div>
              <div className="text-gray-300">Gstaad</div>
              <div className="text-gray-300">Verbier</div>
              <div className="text-gray-300">Crans-Montana</div>
              <div className="text-gray-300">Zermatt</div>
              <div className="text-gray-300">{translate('airports')}</div>
            </div>
          </div>
        </div>

        {/* Social Links & Certifications */}
        <div className="py-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-4">
              <span className="text-gray-300">{translate('followUs')}</span>
              <div className="flex space-x-4">
                <Facebook className="w-5 h-5 text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors" />
                <Twitter className="w-5 h-5 text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors" />
                <Instagram className="w-5 h-5 text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors" />
                <Linkedin className="w-5 h-5 text-gray-400 hover:text-yellow-400 cursor-pointer transition-colors" />
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <div className="text-sm text-gray-400">
                {translate('certified')}
              </div>
              <div className="text-sm text-gray-400">
                {translate('license')}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-6 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2024 Luxor Limousine SA. {translate('allRightsReserved')}
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span className="hover:text-yellow-400 cursor-pointer transition-colors">
                {translate('legalNotices')}
              </span>
              <span className="hover:text-yellow-400 cursor-pointer transition-colors">
                {translate('privacyPolicy')}
              </span>
              <span className="hover:text-yellow-400 cursor-pointer transition-colors">
                {translate('termsConditions')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;